import { rankingItems } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">热度榜单</h2>
          <p className="text-foreground-500 text-sm mt-2">实时热度排行，看看大家最关心什么瓜</p>
        </div>

        <div className="max-w-[800px] mx-auto">
          {rankingItems.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-4 py-4 border-b border-background-200/60 last:border-b-0 hover:bg-background-100/50 transition-colors cursor-pointer px-3 rounded-md -mx-3"
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-md text-sm font-bold flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-primary-300 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2">{item.title}</p>
              </div>
              <div className="flex items-center gap-4 flex-shrink-0">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.views} 阅读</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}